import { RECEIVE_ALL_TAGS, UPDATE_ASSIGNED_TAGS, UPDATE_ADDED_TAGS } from '../actions/tag_actions';
import { REMOVE_WORK_INSTRUCTION } from '../actions/wi_actions'
import {mapKeys, cloneDeep} from 'lodash'
//lodash merge does a deeply nested merge vs Object.assign
const tags_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    switch (action.type) {
        case RECEIVE_ALL_TAGS:
            const tags = mapKeys(action.tags, "_id")
            let normalizedTags = { ...oldState, ...tags }
            return normalizedTags
        case UPDATE_ASSIGNED_TAGS:
            const newTags = mapKeys(action.tags.tags, '_id')
            return {...oldState, ...newTags}
        case UPDATE_ADDED_TAGS:
                const newlyAddedTags = mapKeys(action.tags.tags, '_id')
            return { ...oldState, ...newlyAddedTags}
        case REMOVE_WORK_INSTRUCTION:
            const nextState = cloneDeep(oldState)
            let deletedWip = action.workInstruction.wip_id
            action.workInstruction.tags.forEach(tagId => {
                let nextwips = nextState[tagId].wips.filter(wip => wip !== deletedWip)
                if (nextwips.length > 0) {
                    nextState[tagId].wips = nextwips
                } else {
                    delete nextState[tagId]
                }
            })
            return nextState
        default:
            return oldState;
    }
};

export default tags_reducer;